import { Koi } from '@ksyos/koi';
import { KisType } from '../enums/kisType';

export const KisSettingAddEditDefault: IKisSettingAddEditValidated = {
    password: null,
    serverAddress: '',
    serverPort: '',
    type: KisType.Care2U,
    username: null,
};

export interface IKisSettingAddEditValidated {
    groupId?: string;
    id?: string;

    password: string | null;
    serverAddress: string;
    serverPort: string;
    type: KisType;
    username: string | null;
}

export const KisSettingEdit = Koi.object({
    id: Koi.string().uuid().optional(),
    password: Koi.string().max(255).allow(null),
    serverAddress: Koi.string().max(255),
    serverPort: Koi.string().max(255),
    type: Koi.koi().enum(KisType),
    username: Koi.string().max(255).allow(null),
});
